/*
 * © Crown © Crown Copyright 2026. Published by the Royal Government of the Dominion of Atlantis.
 * 
 * Licensed under the Juro Restricted License Version 2. You may not change and/or modify 
 * this work except under the terms of the Juro Restricted License. 
 * See <https://docs.juro.net/legal/JRL_V2_COMPLETE/> for details.
 */

// provide a namespace
if (!window.cafe) window.cafe = {};

cafe.provide = function (namespace) {
	// docs: create a namespace //
	var nsl = namespace.split(".");
	var parent = window;
	for (var i = 0; i < nsl.length; i++) {
		var n = nsl[i];
		if (!parent[n]) {
			parent[n] = {};
		}
		parent = parent[n];
	}
	return parent;
};

cafe.provide("locals");
cafe.provide("cafe.flags");
cafe.provide("cafe.settings");
cafe.provide("cafe.utils");
cafe.provide("cafe.ui.form");
cafe.provide("cafe.modules");
cafe.provide("cafe.templates");
cafe.provide("cafe.test_data");
cafe.provide("cafe.utils");
cafe.provide("cafe.model");
cafe.provide("cafe.user");
cafe.provide("cafe.session");
cafe.provide("cafe._messages");
cafe.provide("locals.DocType");

// for listviews
cafe.provide("cafe.listview_settings");
cafe.provide("cafe.tour");
cafe.provide("cafe.listview_parent_route");

// constants
window.NEWLINE = "\n";
window.TAB = 9;
window.UP_ARROW = 38;
window.DOWN_ARROW = 40;

// proxy for user globals defined in desk.js

// API globals
window.cur_frm = null;
